export const themeOptions = [
  { id: 'nightfall', label: 'Nightfall', color: '#241438' },
  { id: 'noir-red', label: 'Noir Rot', color: '#b20d1b' },
  { id: 'clarity-blue', label: 'Klar Blau', color: '#1463d9' }
] as const;

export type AppTheme = typeof themeOptions[number]['id'];

const storageKey = 'chronis.theme.v1';

export function readStoredTheme(): AppTheme {
  try {
    const value = window.localStorage.getItem(storageKey);
    return themeOptions.some((theme) => theme.id === value) ? value as AppTheme : 'nightfall';
  } catch {
    return 'nightfall';
  }
}

export function applyTheme(theme: AppTheme) {
  const option = themeOptions.find((item) => item.id === theme) ?? themeOptions[0];
  document.documentElement.dataset.theme = option.id;
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', option.color);
  try { window.localStorage.setItem(storageKey, option.id); } catch { /* Speicherung ist optional. */ }
}
